import { buildProps, definePropType } from '@sgui-plus/utils/props'
import type { Component } from 'vue'

export const minizeBoxProps = buildProps({
  title: {
    type: String,
    default: ''
  },
  closable: {
    type: Boolean,
    default: true,
  },
  closeIcon: {
    type: definePropType<string | Component>([String, Object]),
    default: '',
  }
} as const)

export const minizeBoxEmits = {
  restore: () => true,
  close: () => true
}
